import React, { useState, useEffect } from 'react'
import Navbar from './Navbar'
import "../css/Contact.css"
import gsap from 'gsap/gsap-core';
import { Bounce } from 'gsap/gsap-core';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

function Contact() {

    useEffect(() => {
        gsap.from('.contact__ping', { y: -200, duration: 1.2, ease: Bounce.easeOut, opacity: 0 })

    }, [])

    const [email, setemail] = useState()
    const [subject, setsubject] = useState()
    const [message, setmessage] = useState()
    const [readOnly, setreadOnly] = useState(false)

    const toastId = React.useRef(null);

    const notify = () => toastId.current = toast.info('Sending.....', {
        position: "bottom-left",
        progress: 0,
    });

    const dismiss = () => toast.dismiss(toastId.current);

    const success = () => toast.success('Sent Successfully', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const errorMail = () => toast.error('Sorry Cannot send mail', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const handleClick = (e) => {
        e.preventDefault()
        notify()
        setreadOnly(true)
        axios.post("http://localhost:3001/mail", {
            email: email,
            subject: subject,
            message: message
        }).then(res => {
            if (res.status == 200) {
                setemail("")
                setmessage("")
                setsubject("")
                setreadOnly(false)
                dismiss()
                success()
            }
        }).catch(err => alert(err))
    }

    return (
        <div className='contact'>
            <ToastContainer
                position="bottom-left"
            // hideProgressBar={false}
            // newestOnTop={false}
            // closeOnClick={false}
            // rtl={false}
            // pauseOnFocusLoss={false}
            // draggable={false}
            // pauseOnHover
            />
            <div className="contact__full">
                <div className="contact__div">
                    <form onSubmit={handleClick}>
                        <div className="contact__logo"></div>
                        <div className="contact__fields">
                            <div className="contact__email__subject">
                                <div className="contact__email">
                                    <input onChange={(e) => setemail(e.target.value)} value={email} className="email__input" type="email" readOnly={readOnly} placeholder="Email" required />
                                </div>
                                <div className="contact__subject">
                                    <input onChange={(e) => setsubject(e.target.value)} value={subject} className="subject__input" type="text" readOnly={readOnly} placeholder="Subject" />
                                </div>
                            </div>
                            <div>
                                <div className="contact__email__content">
                                    <textarea onChange={(e) => setmessage(e.target.value)} value={message} rows="3" className="email__content__input" type="text" readOnly={readOnly} placeholder="Message" required />
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="send__button">Send</button>
                    </form>
                </div>
                <div className="contact__left">
                    <div className="contact__offer1">
                        Got Ideas Looking for Collab
                    </div>
                    <div className="contact__offer2">
                        Need a freelancer to Oversight and Maintainence
                    </div>
                    <div className="contact__offer3">
                        Need a hand in Web or(and) App Dev
                    </div>
                    <div className="contact__ping">
                        Ping Me and Catch me on Social
                    </div>
                    <div className="contact__social__icons">
                        <a href="https://linkedin.com/in/shyam-sundar-b-6803481a6 " target='_blank'><LinkedInIcon style={{ fontSize: 40 }} /></a>
                        <a href="https://github.com/Shyam19sundar" target='_blank'><GitHubIcon style={{ fontSize: 40 }} /></a>
                        <a href="https://instagram.com/shyam._.sundar?utm_medium=copy_link" target='_blank'><InstagramIcon style={{ fontSize: 40 }} /></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
